import { API } from "../../../utils";

export const getStampCardsListApi = async (query) => {
  const res = await API.get(`stamp-cards`, query);
  return res.data;
};

export const createStampCardApi = async (payload) => {
  const res = await API.post(`stamp-cards`, payload);
  return res.data;
};

export const updateStampCardApi = async (id, payload) => {
  const res = await API.put(`stamp-cards/${id}`, payload);
  return res.data;
};

export const getStampCardDetailsApi = async (id) => {
  const res = await API.get(`stamp-cards/${id}`);
  return res.data;
};

export const deleteStampCardApi = async (id) => {
  const res = await API.delete(`stamp-cards/${id}`);
  return res.data;
};

export const getStampCardProductsApi = async (stampCardId, params) => {
  const res = await API.get(`stamp-cards/${stampCardId}/products`, { params });
  return res.data;
};

export const deleteStampCardProductApi = async (stampCardId, productId) => {
  const res = await API.delete(
    `stamp-cards/${stampCardId}/products/${productId}`,
  );
  return res.data;
};

export const assignProductToStampCardApi = async (stampCardId, payload) => {
  const res = await API.post(`stamp-cards/${stampCardId}/products`, payload);
  return res.data;
};

export const getStampCardRewardApi = async (stampCardId) => {
  const res = await API.get(`stamp-cards/${stampCardId}/rewards`);
  return res.data;
};

export const getStampCardRewardDetailsApi = async (id, stampCardId) => {
  const res = await API.get(`stamp-cards/${id}/rewards/${stampCardId}`);
  return res.data;
};

export const createStampRewardApi = async (id, payload) => {
  const res = await API.post(`stamp-cards/${id}/rewards`, payload);
  return res.data;
};

export const updateStampRewardApi = async (id, rid, payload) => {
  const res = await API.put(`stamp-cards/${id}/rewards/${rid}`, payload);
  return res.data;
};

export const deleteStampRewardApi = async (id, rid) => {
  const res = await API.delete(`stamp-cards/${id}/rewards/${rid}`);
  return res.data;
};

export const stampStatusChangeApi = async (id, statusID) => {
  const res = await API.post(`stamp-cards/${id}/change-status/${statusID}`);
  return res.data;
};

export const getStampUsageHistoryApi = async (id, query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  let url = `stamp-cards/${id}/usage-history?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};
export const getStampCardCustomersApi = async (stampCardId, query) => {
  const res = await API.get(`stamp-cards/${stampCardId}/customers`, query);
  return res.data;
};

export const deleteStampCardCustomerApi = async (stampCardId, customerId) => {
  const res = await API.delete(
    `stamp-cards/${stampCardId}/customers/${customerId}`,
  );
  return res.data;
};

export const assignCustomerToStampCardApi = async (stampCardId, payload) => {
  const res = await API.post(`stamp-cards/${stampCardId}/customers`, payload);
  return res.data;
};

export const getStampCardsSettingsApi = async () => {
  const res = await API.get("stamp-cards/settings");
  return res.data;
};

export const updateStampCardsSettingsApi = async (payload) => {
  const res = await API.put("stamp-cards/settings", payload);
  return res.data;
};